import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy /account/user/health-vault = redirect to /medical-vault.
 * The vault root opens on the passport tab.
 */
export const Route = createFileRoute("/_authenticated/account/user/health-vault")({
  beforeLoad: () => {
    throw redirect({
      to: "/account/user/medical-vault",
      search: { tab: "passport", subtab: "active" } as never,
    });
  },
});
